<!-- Divider -->
<div
    class="cb-vertical-navigation-item-wrapper divider"
    [ngClass]="item.classes?.wrapper"></div>
